import { TYPE_CARD } from "app/common/LocalConst";
import { RegisterCard } from "app/common/Model/RegisterCard";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingPatientTransaction } from "app/services/PatientTransaction";
import {
  getTreatmentPlanCardById,
  pagingTreatmentPlanCard,
  removeTreatmentPlanCard,
  saveOrEditTreatmentPlanCard,
} from "app/services/TreatmentPlanCardService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class TreatmentPlanCardStore {
  searchRegisterCard = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    type: TYPE_CARD[0].value,
  };
  searchHistoryUsedCard = {
    ...new SearchObject(),
    prepaidCardId: null,
  };

  openConfirmDelete = null;
  openConfirmMessage = null;

  pageRegisterCard = new PageResponse();
  openCreateOrEditCardPopup = false;
  initRegisterCard = { ...new RegisterCard() };
  openHistoryUsedCard = false;
  pageHistoryUsedCard = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }
  pagingRegisterCard = async () => {
    let { departmentId, clientCardId, ...ortherData } = this.searchRegisterCard;

    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    } else {
      toast.error("Vui lòng chọn cơ sở");
      return;
    }
    if (clientCardId) {
      ortherData.clientCardId = clientCardId?.id;
    }
    return await pagingTreatmentPlanCard({ ...ortherData })
      .then(({ data }) => {
        this.pageRegisterCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  saveOrUpdateRegisterCard = async (values) => {
    let { cardUsers, ...ortherData } = values;
    if (cardUsers && cardUsers?.length > 0) {
      ortherData.cardUsers = cardUsers?.map((el) => ({
        ...el,
        patient: { id: el?.patient?.id },
      }));
    }
    return await saveOrEditTreatmentPlanCard({ ...ortherData })
      .then(({ data }) => {
        this.openCreateOrEditCardPopup = false;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Đăng ký thẻ trả trước thành công");
          this.pagingRegisterCard();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký thẻ trả trước có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterCard) => {
    this.searchRegisterCard = {
      ...this.searchRegisterCard,
      ...searchRegisterCard,
    };
    this.pagingRegisterCard();
  };

  handleOpenCreateOrEditCardPopup = async (cardRegister) => {
    if (Boolean(cardRegister)) {
      getTreatmentPlanCardById(cardRegister?.id).then(({ data }) => {
        if (data?.taxPercent) data.taxPercent = data?.taxPercent?.toString();
        data.totalAmount = data?.quantity * data?.price;
        this.initRegisterCard = data;
        this.openCreateOrEditCardPopup = true;
      });
    } else {
      this.initRegisterCard = { ...new RegisterCard() };
      this.openCreateOrEditCardPopup = true;
    }
  };

  handleCloseCreateOrEditCardPopup = () => {
    this.openCreateOrEditCardPopup = false;
    this.initRegisterCard = { ...new RegisterCard() };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteCard = async () => {
    return await removeTreatmentPlanCard(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail);
        } else {
          toast.success("Xóa thẻ trả trước thành công");
          this.pagingRegisterCard();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa thẻ trả trước có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  getHistoryUsedCard = async () => {
    return await pagingPatientTransaction({ ...this.searchHistoryUsedCard })
      .then(({ data }) => {
        this.pageHistoryUsedCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử sử dụng thẻ trả trước có lỗi");
      });
  };

  handleOpenHistoryCardPopup = async (cardId) => {
    this.searchHistoryUsedCard = {
      ...this.searchHistoryUsedCard,
      prepaidCardId: cardId,
    };
    await this.getHistoryUsedCard();
    this.openHistoryUsedCard = true;
  };

  handleCloseHistoryUsedPopup = () => {
    this.openHistoryUsedCard = false;
    this.pageHistoryUsedCard = new PageResponse();
  };
  handleChangeFormSearchHistoryUsedCard = (searchObj) => {
    this.searchHistoryUsedCard = {
      ...this.searchHistoryUsedCard,
      ...searchObj,
    };
    this.getHistoryUsedCard();
  };

  resetStore = () => {
    this.searchRegisterCard = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
      type: TYPE_CARD[0].value,
    };
    this.pageRegisterCard = new PageResponse();
    this.openCreateOrEditCardPopup = false;
    this.openConfirmMessage = null;
    this.initRegisterCard = { ...new RegisterCard() };
    this.promotionPrograms = [];
  };
}
